module.exports = __webpack_public_path__ + "operace-nosu_2_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-nosu_2_after.jpg
// module id = 1131
// module chunks = 0